import type { IconPrimitives, IconProps } from './types';

export const buildCheckboxIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  DefaultCheckboxIcon: ({ color = defaultColor, size = 16, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none' {...props}>
      <Rect x='0.5' y='0.5' width='15' height='15' stroke={color} />
    </Svg>
  ),
  SelectedCheckboxIcon: ({ color = defaultColor, size = 16, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none' {...props}>
      <Rect width='16' height='16' fill={color} />
      <Path d='M4 9.06572L6.4 11L12 5' stroke='white' strokeLinecap='square' strokeLinejoin='round' />
    </Svg>
  ),
});
